import type { ApolloCache } from '@apollo/client'
import { type Image, Media } from '@gql-generated/graphql'

export function invalidateAvailablePointsOfSale(cache: ApolloCache<unknown>) {
  cache.evict({
    id: cache.identify({ __typename: 'Shipping' }),
    fieldName: 'availablePointsOfSale',
  })
}

export function getPointOfSalePicture({
  cmsImage,
  cmsImageUrl,
  themeFallbackImage,
  alt,
}: {
  cmsImage?: Image | null
  cmsImageUrl?: string | null
  themeFallbackImage?: string
  alt: string
}): Image {
  // Use CMS image fragment if available
  if (cmsImage?.set?.length && cmsImage.set[0]) {
    return cmsImage
  }

  // Fallback to URL string (CMS or Theme)
  const imageUrl = cmsImageUrl || themeFallbackImage || ''

  return {
    alt,
    set: imageUrl
      ? [
          { url: imageUrl, media: Media.Mobile },
          { url: imageUrl, media: Media.Desktop },
        ]
      : [],
  }
}
